var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 11.25C13.1143 11.25 12.3429 11.5875 11.5714 12.15L7.45714 10.125C7.58571 9.7875 7.71429 9.3375 7.71429 9C7.71429 8.6625 7.58571 8.2125 7.45714 7.875L11.5714 5.85C12.3429 6.4125 13.1143 6.75 14.1429 6.75C16.3286 6.75 18 5.2875 18 3.375C18 1.4625 16.3286 0 14.1429 0C11.9571 0 10.2857 1.4625 10.2857 3.375V3.9375L5.78571 6.075C5.27143 5.85 4.62857 5.625 3.85714 5.625C1.8 5.625 0 7.0875 0 9C0 10.8 1.8 12.375 3.85714 12.375C4.62857 12.375 5.27143 12.15 5.78571 11.925L10.2857 14.0625V14.625C10.2857 16.5375 11.9571 18 14.1429 18C16.3286 18 18 16.5375 18 14.625C18 12.7125 16.3286 11.25 14.1429 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.6bea5713f8bd458dab6a2c76e7b5e6cd.svg";
export { ForwardRef as ReactComponent };